import React from 'react';
import { renderClassNames } from '../../helpers/markup.helper';
export default function CardHeading({ children, classNames }) {

    return (
        <div className={renderClassNames('card-header', classNames)}>
            {children}
        </div>
    )
}